import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

interface IStylesProps {
  isPreview?: boolean;
}

export default makeStyles<MuiTheme, IStylesProps>((theme: MuiTheme) => ({
  barn: {},
  hasHorses: {
    cursor: ({ isPreview }) => (isPreview ? "default" : "pointer"),
    "& $barnPath": {
      fill: "#6bc285"
    },
    "& $circle": {
      fill: "#f3f5ea"
    },
    "& $circleOutline": {
      fill: "#009444"
    }
  },
  circle: {
    fill: "transparent"
  },
  circleOutline: {
    fill: "transparent"
  },
  barnPath: {
    fill: "#d7d9d1"
  },
  cls1: {
    fill: "none"
  },
  cls2: {
    clipPath: "url(#clippath)"
  },
  cls3: {
    fill: "#fdfce8"
  },
  cls4: {
    fill: "#ebf3d6"
  },
  cls5: {
    fill: "#dcecc8"
  },
  cls6: {
    fill: "#fef0f3"
  },
  cls7: {
    fill: "#fff"
  },
  cls8: {
    fill: "#ffefdb"
  },
  cls9: {
    fill: "#fafbf0"
  },
  cls10: {
    fill: "#dfecbc"
  },
  cls11: {
    fill: "#c2e8fa"
  },
  cls12: {
    fill: "#fdfbe0"
  },
  cls13: {
    fill: "#333"
  },
  cls14: {
    fill: "gray"
  },
  cls15: {
    fill: "#f2f2f2"
  },
  cls32: {
    fill: "#231f20"
  },
  cls16: {
    fill: "#231f20",
    opacity: 0.2
  },
  cls17: {
    fill: "#d7d9d1"
  },
  cls18: {
    fill: "#9ea19d"
  },
  cls19: {
    fill: "#8d908c"
  },
  cls20: {
    fill: "#989b96"
  },
  cls21: {
    fill: "#999c98"
  },
  cls22: {
    fill: "#a3a6a1"
  },
  cls23: {
    fill: "#a0a39e"
  },
  cls24: {
    fill: "#939691"
  },
  cls25: {
    fill: "#969994"
  },
  cls26: {
    fill: "#999c97"
  },
  cls27: {
    fill: "#9da09c"
  },
  cls28: {
    fill: "#919490"
  },
  cls29: {
    fill: "#9a9d99"
  },
  cls30: {
    fill: "#8e918d"
  },
  cls31: {
    fill: "#a2a5a1"
  },
  cls33: {
    fill: "#808285"
  },
  cls34: {
    fill: "#939598"
  },
  cls35: {
    fill: "#010101"
  },
  cls36: {
    fill: "#9c9f9a"
  },
  cls37: {
    fill: "#989b97"
  },
  cls38: {
    fill: "#979a95"
  },
  cls39: {
    fill: "#d7d9d1"
  },
  cls40: {
    fill: "#f3f5ea"
  },
  cls41: {
    fill: "#009444"
  },
  cls42: {
    isolation: "isolate"
  }
}));
